import React, { createContext, useContext } from 'react';

type SlideoverContextType = {
  isFullScreen: boolean;
};

const SlideoverContext = createContext<SlideoverContextType>({
  isFullScreen: false,
});

export const useSlideover = () => useContext(SlideoverContext);

export const SlideoverProvider: React.FC<{
  children: React.ReactNode;
  isFullScreen: boolean;
}> = ({ children, isFullScreen }) => {
  return (
    <SlideoverContext.Provider value={{ isFullScreen }}>
      {children}
    </SlideoverContext.Provider>
  );
};
